import axios from 'axios';
import { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import useLocalStorage from 'react-use-localstorage';
import { NodeServer } from '../config';
import menuClose from '../images/menu-close.png';
import menu from '../images/mobile-menu.png';
import userImg from '../images/user.png';
import '../styles/Navbar.scss';
import Popup from './Popup';

type NavbarProps = {
  showClose: boolean;
  onMenuIconClick: () => void;
};

const Navbar: React.FC<NavbarProps> = (props) => {
  const [hide, setHide] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [userName, setUserName] = useLocalStorage('userName', '');

  const { pathname } = useLocation();

  const onUserIconClick = () => {
    setShowPopup(!showPopup);
  };

  const onPopupToggle = async (event: React.MouseEvent<HTMLElement>) => {
    const menuId = event.currentTarget.getAttribute('data-id');
    setShowPopup(false);
    if (menuId === 'SIGN-OUT') {
      setUserName('');
      await axios.get<any>(`${NodeServer.baseURL}${NodeServer.logOut}`, {
        withCredentials: true,
      });
    }
  };

  const onMenuClick = () => {
    props.onMenuIconClick();
  };

  useEffect(() => {
    const routesWithoutNavBar = ['/avatar'];
    setHide(routesWithoutNavBar.includes(pathname));
  }, [pathname]);

  const menuItems = [
    {
      id: 'PROFILE',
      title: 'Profile',
      navLink: '/user-profile',
    },
    {
      id: 'SIGN-OUT',
      title: 'Sign out',
      navLink: '/sign-in',
    },
  ];

  return !hide ? (
    <div className="navbar">
      <ul>
        <li>
          <NavLink
            to="/gallery"
            style={({ isActive }) => ({
              opacity: isActive ? 1 : 0.6,
            })}
          >
            Gallery
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/technologies"
            style={({ isActive }) => ({
              opacity: isActive ? 1 : 0.6,
            })}
          >
            Technologies
          </NavLink>
        </li>
      </ul>
      <NavLink className="home-link" to="/home">
        ALNAIR<span className="version">3.0</span>
      </NavLink>
      {!props.showClose && (
        <img className="menu" onClick={onMenuClick} src={menu} alt="menu"></img>
      )}
      {props.showClose && (
        <img
          className="menu"
          onClick={onMenuClick}
          src={menuClose}
          alt="close"
        ></img>
      )}

      <ul>
        <li>
          <NavLink
            to="/contact-us"
            style={({ isActive }) => ({
              opacity: isActive ? 1 : 0.6,
            })}
          >
            Contact us
          </NavLink>
        </li>

        {userName ? (
          <li>
            <NavLink
              className="user-name"
              to="/user-profile"
              style={({ isActive }) => ({
                opacity: isActive ? 1 : 0.6,
              })}
            >
              {userName}
            </NavLink>
            <img src={userImg} onClick={onUserIconClick} alt="User"></img>
          </li>
        ) : (
          <li>
            <NavLink
              to="/sign-in"
              style={({ isActive }) => ({
                opacity: isActive ? 1 : 0.6,
              })}
            >
              Sign In
            </NavLink>
          </li>
        )}
      </ul>
      {showPopup && (
        <Popup menuItems={menuItems} onClick={onPopupToggle}></Popup>
      )}
    </div>
  ) : null;
};

export default Navbar;
